<div class="error-text">
    <h2>{{title}}</h2>
</div>

<div class="submit-button">
    <button class="btn btn-tbl-outline-secondary mb-2" (click)="onHideModal()">OK</button>
</div>